/**
 * Fury Lab email templates.
 * Placeholders: {{participantName}}, {{eventDate}}, {{blockSummary}}, {{meetTime}}, {{coachName}}
 */

export const FURY_LAB_INITIAL = 'fury_lab_initial';
export const FURY_LAB_REMINDER = 'fury_lab_reminder';

export const FURY_LAB_TEMPLATES = [
  {
    key: FURY_LAB_INITIAL,
    label: 'Fury Lab – Initial (e.g. a few weeks before)',
    defaultSubject: 'Fury Lab at Fresh Meet – Your time slots',
    defaultBody: `Hi {{participantName}},

You're signed up for Fury Lab at Fresh Meet on {{eventDate}}.

Meet time: {{meetTime}}

Your assigned blocks:
{{blockSummary}}

We'll send a reminder closer to the event. If anything changes, reply to this email.

See you there!`,
  },
  {
    key: FURY_LAB_REMINDER,
    label: 'Fury Lab – Reminder (closer to the event)',
    defaultSubject: 'Reminder: Fury Lab at Fresh Meet – {{eventDate}}',
    defaultBody: `Hi {{participantName}},

This is a reminder that you're signed up for Fury Lab at Fresh Meet on {{eventDate}}.

Meet time: {{meetTime}}

Your blocks:
{{blockSummary}}

See you there!`,
  },
];

/**
 * Replace placeholders in a string.
 * @param {string} str
 * @param {{ participantName?: string, eventDate?: string, blockSummary?: string, meetTime?: string, coachName?: string }} vars
 * @returns {string}
 */
export function applyFuryLabPlaceholders(str, vars = {}) {
  if (!str || typeof str !== 'string') return '';
  let out = str;
  out = out.replace(/\{\{participantName\}\}/g, vars.participantName ?? '');
  out = out.replace(/\{\{eventDate\}\}/g, vars.eventDate ?? '');
  out = out.replace(/\{\{blockSummary\}\}/g, vars.blockSummary ?? '');
  out = out.replace(/\{\{meetTime\}\}/g, vars.meetTime ?? '');
   out = out.replace(/\{\{coachName\}\}/g, vars.coachName ?? '');
  return out;
}
